import * as React from 'react';
import { StateContext } from '../services/LabSimService';
import ErrorModal from '../controls/ErrorModal';
import { T } from '@testout/labsim-ui-atomics';
import styles from './PageFooter.module.less';
export default class PageFooter extends React.Component {
    getYear() {
        return new Date().getFullYear();
    }
    render() {
        const integrationLink = 'https://help.comptia.org/hc/en-us/sections/15483943055252-LMS-Integration-2024';
        return (React.createElement(StateContext.Consumer, null, (stateContext) => {
            //const integrationLink = useMemo(() => getIntegrationGuide(this.stateContext.serverState), [this.stateContext]);
            return (React.createElement("div", { className: styles.footer },
                React.createElement("div", { className: styles.footerLinks },
                    React.createElement(T.Link, { automationId: 'supportLink', href: 'https://www.comptia.org/contact-us', target: '_blank' }, "Support"),
                    integrationLink && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: styles.divider }),
                        React.createElement(T.Link, { automationId: 'guideLink', href: integrationLink, target: '_blank' }, "Integration Guide")))),
                React.createElement("div", { className: styles.copyrightText },
                    "Copyright \u00A9",
                    ' ',
                    `${this.getYear()} The Computing Technology Industry Association, Inc.`),
                stateContext &&
                    stateContext.isFamilyCanvas() &&
                    stateContext.canvasDataFailed && (React.createElement(ErrorModal, { title: 'Network Error', body: React.createElement(React.Fragment, null,
                        "We had trouble obtaining critical data from Canvas.",
                        React.createElement("br", null),
                        React.createElement("br", null),
                        "Please try relaunching the app or contact CompTIA support.") })),
                stateContext &&
                    stateContext.isFamilyCanvas() &&
                    !stateContext.isIntegrationLTIAdvantage() &&
                    stateContext.canvasDataLoaded &&
                    stateContext.canvasAssignmentGroups.length === 0 && (React.createElement(ErrorModal, { title: 'No Canvas Assignment Groups', body: React.createElement(React.Fragment, null,
                        "Canvas failed to return any assignment groups for your course.",
                        React.createElement("br", null),
                        React.createElement("br", null),
                        "If this course is new or has been recently reset, you may need to click the Assignments link within Canvas to prompt creating your default Assignments group and then relaunch this app.") }))));
        }));
    }
}
//# sourceMappingURL=PageFooter.js.map